import type { NewsItem } from "@/types/content";

export const newsItems: NewsItem[] = [
  {
    id: "news-festival-closing",
    title: "天马影展落幕：《星际回声》斩获最佳视觉效果与观众选择双奖",
    date: "2025-10-15",
    category: "资讯",
    summary:
      "为期九天的天马影展昨晚闭幕，科幻片《星际回声》拿下最佳视觉效果与观众选择两项大奖，成为本届最大赢家。",
    content: [
      "为期九天的天马影展昨晚在滨海艺术中心闭幕。闭幕片《星际回声》放映结束后，全场观众起立鼓掌近四分钟，这也是本届影展唯一一次出现持续鼓掌的场次。",
      "评委会在颁奖词中写道：「影片用极少的对白建立了一个可信的近未来宇宙，视觉奇观始终服务于人物情感，而不是相反。」除最佳视觉效果外，《星际回声》同时获得观众选择奖。",
      "值得一提的是，本届影展的观众选择奖由现场两千余名观众实时投票产生。《星际回声》以 41% 的得票率领先第二名《山海之间》近十个百分点。",
      "影展组委会同时宣布，下一届影展将增设「新导演长片」单元，报名通道于下月开启。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photo%20style%20image%20of%20a%20film%20festival%20red%20carpet%20at%20night%2C%20elegant%20crowd%20silhouettes%20and%20warm%20spotlights%2C%20deep%20navy%20backdrop%2C%20cinematic%20atmosphere%2C%20landscape%20composition&width=600&height=400&seq=tm-news-festival&orientation=landscape",
    hot: 96,
    relatedMediaId: "interstellar-echo",
  },
  {
    id: "news-dark-tide-season2",
    title: "《暗涌之城》第二季官宣开机，原班人马悉数回归",
    date: "2025-10-13",
    category: "资讯",
    summary:
      "出品方今日确认，《暗涌之城》第二季已在港城开机，张宗翰、苏梨领衔主演，故事将转向航运网络的上游。",
    content: [
      "出品方今日发布开机照，确认《暗涌之城》第二季正式开拍。第一季导演陈立行继续执导，张宗翰、苏梨、何启南等主演全部回归，新增角色由林知夏出演。",
      "据主创透露，第二季的故事将从港城转向航运网络的上游：一座位于内河口岸的旧仓库，和一桩被压在卷宗最底层的事故。第一季中留下的两处伏笔将在新一季中得到回应。",
      "制片人表示，第二季仍保持 24 集的体量，预计明年下半年与观众见面。「我们不想把故事拉长，只想把问题问得更深。」",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Press%20conference%20stage%20with%20microphones%20and%20warm%20stage%20lighting%2C%20blurred%20photographers%20in%20foreground%2C%20deep%20navy%20background%2C%20cinematic%20editorial%20style%2C%20landscape%20composition&width=600&height=400&seq=tm-news-press&orientation=landscape",
    hot: 92,
    relatedMediaId: "dark-tide-city",
  },
  {
    id: "news-snowline-review",
    title: "深度｜从《雪线以南》看战争片的克制表达",
    date: "2025-10-10",
    category: "影评",
    summary:
      "没有一场正面战场，没有一句口号，《雪线以南》把战争片的重心从胜负移到了人身上。这或许是它最难得的地方。",
    content: [
      "《雪线以南》上映一年后重看，仍然会被那组长达三分钟的空镜击中。雪线之上，七个人，一部电台，十四天。影片几乎放弃了所有战争片惯用的语法。",
      "导演韩牧川在一次访谈中说，他感兴趣的不是「怎么打赢」，而是「怎么活下去」。所以镜头始终贴近人物：冻裂的手、分到最后半块的压缩饼干、有人在雪地里轻声数着自己的脚步。",
      "最难得的是影片对沉默的使用。全片台词不到四百句，大部分时候只有风声与呼吸。当最后一名士兵把电台交出去，观众才意识到，被护送的不是设备，而是一群人愿意相信的东西。",
      "如果说近年华语战争片有什么新的可能，《雪线以南》给出的答案是：把镜头往后撤一步。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Outdoor%20film%20shoot%20on%20a%20misty%20mountain%20ridge%20with%20camera%20crane%2C%20cold%20blue%20light%20and%20warm%20sunrise%20glow%2C%20cinematic%20documentary%20style%2C%20landscape%20composition&width=600&height=400&seq=tm-news-snowline&orientation=landscape",
    hot: 88,
    relatedMediaId: "south-of-snowline",
  },
  {
    id: "news-white-horse-bts",
    title: "幕后｜《少年白马》的竹林打戏，是怎样拍出来的",
    date: "2025-10-08",
    category: "幕后",
    summary:
      "一场四分钟的长镜头打戏，剧组在竹林里拍了十一天。动作指导说，最难的不是招式，是让风也参与表演。",
    content: [
      "《少年白马》第三集那场竹林对决，被观众剪成各种角度的短视频反复传播。很少有人知道，这个四分钟的长镜头，剧组拍了十一天。",
      "动作指导团队在开拍前三个月就开始勘景，最终选定一片有天然坡度的竹林。「平地上打，镜头只能横着走；有坡度，人和竹子就能形成层次。」",
      "为了让风「参与表演」，剧组在竹林外围架设了六台大型风机，配合实时的风向调整。演员顾清让为此提前两个月进组训练，其中有一个后撤步的镜头重拍了三十七次。",
      "制片人透露，全剧共有大小动作场面四十六场，全部采用实景拍摄，没有使用虚拟棚。「我们想让观众相信，那个江湖是真的有竹子的。」",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20a%20director%20and%20camera%20crew%2C%20warm%20tungsten%20lights%20and%20blue%20dusk%20ambience%2C%20cinematic%20documentary%20style%2C%20landscape%20composition&width=600&height=400&seq=tm-news-bts&orientation=landscape",
    hot: 90,
    relatedMediaId: "white-horse-youth",
  },
  {
    id: "news-award-list",
    title: "第 38 届华语电影季公布入围名单，多部天马展映作品上榜",
    date: "2025-10-05",
    category: "资讯",
    summary:
      "本届华语电影季公布入围名单，《星际回声》《山海之间》《逐光者》共获得十四项提名。",
    content: [
      "第 38 届华语电影季昨日公布入围名单。本届共有 132 部影片报名，最终 21 部进入各单元角逐。",
      "在天马传媒展映专区上线过的作品中，《星际回声》获得最佳影片、最佳导演、最佳视觉效果等六项提名；《山海之间》获得最佳美术指导、最佳原创音乐等四项提名；修复重映的《逐光者》则入围最佳纪录片单元。",
      "评委会主席在发布会上表示，本届报名作品的整体完成度较往年有明显提升，尤其是类型片在叙事上的成熟。「我们看到越来越多的创作者愿意在类型里讲自己的事。」",
      "颁奖礼将于下月中旬举行，天马传媒将同步上线获奖作品专题。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Audience%20silhouettes%20in%20a%20dark%20cinema%20watching%20a%20bright%20screen%2C%20warm%20and%20navy%20light%20spill%2C%20atmospheric%20cinematic%20mood%2C%20landscape%20composition&width=600&height=400&seq=tm-news-award&orientation=landscape",
    hot: 85,
  },
  {
    id: "news-suwan-interview",
    title: "《春日纪事》导演苏晚：把日常拍出光感",
    date: "2025-10-02",
    category: "影评",
    summary:
      "在苏晚的镜头里，晾晒的被子、打开的木窗和一碗放凉的粥，都比情节更重要。我们和她聊了聊「不着急」的拍法。",
    content: [
      "《春日纪事》播出后，被讨论最多的是它的「慢」。二十集里没有反派，没有激烈的冲突，最大的事件是院子要改造。",
      "苏晚说，她一开始就决定不用配乐推动情绪。「音乐一响，观众就知道该难过了。我想让他们自己决定什么时候难过。」全剧只在最后一集用了两段音乐。",
      "谈到那场被反复截图的晾被子戏，她笑着说拍了整整一个下午。「风不对，光也不对。我们要等一个下午三点的斜光，把被子照到半透明。」",
      "「生活本身没有那么强的戏剧性，但它有光。」苏晚说，下一部作品仍然会拍普通人的日子，「只是换一个季节」。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Animation%20studio%20workspace%20with%20storyboards%20and%20glowing%20monitors%2C%20warm%20desk%20lamps%20against%20cool%20blue%20evening%20light%2C%20cinematic%20documentary%20style%2C%20landscape%20composition&width=600&height=400&seq=tm-news-interview&orientation=landscape",
    hot: 83,
    relatedMediaId: "spring-chronicle",
  },
  {
    id: "news-mountain-box-office",
    title: "《山海之间》票房突破十亿，续作进入前期筹备",
    date: "2025-09-28",
    category: "资讯",
    summary:
      "上映第四周，《山海之间》累计票房突破十亿元，片方确认续作已进入剧本打磨阶段，原班主创有望回归。",
    content: [
      "据发行方数据，截至本周二，《山海之间》累计票房正式突破十亿元，成为今年第三部进入十亿俱乐部的华语奇幻片。影片上映第四周仍保持较高的上座率。",
      "片方在庆功会上确认，续作已进入前期筹备，目前处于剧本打磨阶段。导演白泽宇表示，续作不会简单延续第一部的旅程，而是把视角交给山中的旧神。",
      "「第一部的结尾其实留了一个很大的空白，我们想把那个空白填上。」白泽宇说，如果一切顺利，影片将于后年开机。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Misty%20jade%20mountain%20landscape%20at%20sunrise%20with%20layers%20of%20clouds%20and%20a%20solitary%20stone%20path%2C%20soft%20golden%20light%2C%20cinematic%20oriental%20painting%20atmosphere%2C%20landscape%20composition&width=600&height=400&seq=tm-news-boxoffice&orientation=landscape",
    hot: 89,
    relatedMediaId: "between-mountains-seas",
  },
  {
    id: "news-holiday-guide",
    title: "观影指南｜这个档期值得走进影院的五部作品",
    date: "2025-09-26",
    category: "资讯",
    summary:
      "从科幻到战争再到爱情，我们按观影心情整理了五部正在上映的作品，并标注了各自的适合场景。",
    content: [
      "假期临近，院线迎来一年中最拥挤的档期。我们把正在上映的作品按「想看点什么」分成五类，帮你少花一点挑片的时间。",
      "想被震撼：首选《星际回声》，建议选择最大的厅。想安静一会儿：《沙漠玫瑰》，适合一个人看。想和朋友一起讨论：《第七号列车》，循环设定足够聊一整晚。",
      "想带父母：《逐光者》修复版，节奏慢但不闷。想哭一场：《雪线以南》，请自备纸巾。以上排片信息以影院实际场次为准。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Cinema%20lobby%20with%20warm%20amber%20lighting%2C%20popcorn%20bucket%20and%20vintage%20ticket%20stub%20on%20a%20wooden%20counter%2C%20deep%20navy%20shadows%2C%20cinematic%20editorial%20style%2C%20landscape%20composition&width=600&height=400&seq=tm-news-guide&orientation=landscape",
    hot: 80,
  },
  {
    id: "news-dark-tide-set",
    title: "幕后｜《暗涌之城》的港口，是怎样一砖一瓦搭出来的",
    date: "2025-09-22",
    category: "幕后",
    summary:
      "为了拍出真实的码头质感，美术组在废弃船厂里搭了一座 1:1 的集装箱堆场，连吊机的锈迹都按照片还原。",
    content: [
      "《暗涌之城》里那些雨夜码头的镜头，大部分不是在真实港口拍的。美术组在城郊一处废弃船厂里，用四个月时间搭出了一座 1:1 的集装箱堆场。",
      "美术指导说，最难的是「旧」。「新的东西一眼就能看出来。我们要让每一个箱体都有不同的锈迹、不同的编号，连贴纸都得是旧的。」团队参照了上千张实景照片。",
      "码头上的两台吊机是按实拍照片还原的钢架结构，可以真的转动。拍摄期间共使用了十四台造雨机，一场夜戏拍完后，整个片场像被海水泡过一遍。",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Night%20film%20set%20of%20a%20container%20port%20with%20rusty%20shipping%20containers%2C%20cranes%20and%20rain%20machines%2C%20deep%20navy%20sky%20with%20warm%20amber%20work%20lights%2C%20cinematic%20documentary%20style%2C%20landscape%20composition&width=600&height=400&seq=tm-news-sets&orientation=landscape",
    hot: 78,
    relatedMediaId: "dark-tide-city",
  },
];